import { inject, Injectable } from '@angular/core';
import { FormTicketLimitValidity } from '@core/data-access/services/form/form-ticket-limit-validity';
import { some } from 'lodash';
import { combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormValidationProcessing {
  readonly #formTicketLimitValidity = inject(FormTicketLimitValidity);

  readonly #isValidationProcessing$ = this.setIsValidationProcessing();

  get isValidationProcessing$() {
    return this.#isValidationProcessing$;
  }

  private setIsValidationProcessing() {
    const isTicketLimitPerEmailAddressValidationProcessing$ =
      this.#formTicketLimitValidity.getIsTicketLimitPerEmailAddressValidationProcessing$();

    return combineLatest([isTicketLimitPerEmailAddressValidationProcessing$]).pipe(
      map((validationsProcessing) => some(validationsProcessing, (isValidationProcessing) => isValidationProcessing))
    );
  }
}
